// Mirrors the server-side split in packages/api/src/lib/portal-domain-access.ts,
// so the form never rejects a list the portal would happily match.
const DOMAIN =
	/^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/i

export const parseAllowedDomains = (value: string): string[] =>
	value
		.split(/[,\s]+/)
		.map((domain) => domain.trim().toLowerCase())
		.filter(Boolean)

export const isAllowedDomainsList = (value: string): boolean =>
	parseAllowedDomains(value).every((entry) => {
		const [local, domain] = entry.includes("@")
			? entry.split("@")
			: ["x", entry]
		return /^[^\s@]+$/.test(local ?? "") && DOMAIN.test(domain ?? "")
	})
